import Input from './Input';
import InputNumber from './InputNumber';

export default Input;
export { InputNumber };
